<template>
 <quranTem> </quranTem>
</template>

<script>
 import quranTem from "./components/quranTem.vue"

 export default {
  name: "App",
  components: {
   quranTem,
  },
 }
</script>

<style>
 #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 4em;
  border-color: rgb(226, 5, 41);
 }
</style>
